import { writable, readonly } from "svelte/store";

export const BREAKPOINTS = {
  xsmall: 320,
  small: 768,
} as const;

export const getBreakpoint = (size: keyof typeof BREAKPOINTS) => {
  return window.innerWidth > BREAKPOINTS[size];
};

const displayTypeStore = writable<"desktop" | "mobile">("desktop");
export const displayType = readonly(displayTypeStore);

export function initDisplayTypeStore() {
  const matcher = window.matchMedia("(max-width: 768px)");
  const mediaListener = (event: MediaQueryListEvent) => {
    displayTypeStore.set(event.matches ? "mobile" : "desktop");
  };
  matcher.addEventListener("change", mediaListener);
  displayTypeStore.set(matcher.matches ? "mobile" : "desktop");

  return () => {
    matcher.removeEventListener("change", mediaListener);
  };
}

// Assume standard tailwind breakpoints, plus xs
const breaks = {
  xs: [undefined, "320px"],
  sm: ["321px", "640px"],
  md: ["641px", "768px"],
  lg: ["769px", "1024px"],
  xl: ["1025px", "1280px"],
  "2xl": ["1281px", undefined],
};

type Breakpoint = keyof typeof breaks;

const breakpointStore = writable<Breakpoint>("md");
export const breakpoint = readonly(breakpointStore);

export function initBreakpointStore() {
  const removers: (() => void)[] = [];

  function checkMatch(test: { matches: boolean }, name: Breakpoint) {
    if (test.matches) {
      breakpointStore.set(name as Breakpoint);
    }
  }

  for (const [name, value] of Object.entries(breaks)) {
    const matcher = !value[0]
      ? window.matchMedia(`(max-width: ${value[1]})`)
      : !value[1]
        ? window.matchMedia(`(min-width: ${value[0]})`)
        : window.matchMedia(
            `(min-width: ${value[0]}) and (max-width: ${value[1]})`,
          );
    const mediaListener = (event: MediaQueryListEvent) => {
      checkMatch(event, name as Breakpoint);
    };
    matcher.addEventListener("change", mediaListener);
    checkMatch(matcher, name as Breakpoint);
    removers.push(() => matcher.removeEventListener("change", mediaListener));
  }

  return () => {
    removers.forEach((r) => r());
  };
}
